import styled from 'styled-components'

import {
  LANDING_SECTIONS_COLLAPSE_PROPERTY,
  LANDING_SECTIONS_FADE_PROPERTY,
} from './landingSectionsExit'

const STAGE_MOVE = '300ms var(--ease-in-out-strong)'
const STAGE_FADE = '150ms var(--ease-out-strong)'

export const ChatPage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: var(--card);
`

export const ChatColumn = styled.div<{ $hasConversation: boolean }>`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  max-width: 48rem;
  height: 100%;
  min-width: 0;
  min-height: 0;
  margin-inline: auto;
  padding-inline: 1rem;
  padding-top: ${({ $hasConversation }) =>
    $hasConversation ? '0.75rem' : 'clamp(1rem, 5vh, 3rem)'};
  padding-bottom: ${({ $hasConversation }) =>
    $hasConversation ? '0.75rem' : '0'};
  flex-direction: column;
  transition: padding ${STAGE_MOVE};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const LogoStage = styled.div<{ $hasConversation: boolean }>`
  display: flex;
  flex-shrink: 0;
  max-height: ${({ $hasConversation }) => ($hasConversation ? '0' : '10rem')};
  align-items: center;
  justify-content: center;
  overflow: hidden;
  opacity: ${({ $hasConversation }) => ($hasConversation ? 0 : 1)};
  transform: translateY(
    ${({ $hasConversation }) => ($hasConversation ? '-1.5rem' : '0')}
  );
  transition:
    max-height ${STAGE_MOVE},
    opacity ${STAGE_FADE},
    transform ${STAGE_MOVE};

  @media (prefers-reduced-motion: reduce) {
    transform: none;
    transition: opacity ${STAGE_FADE};
  }
`

export const ConversationStage = styled.div<{ $hasConversation: boolean }>`
  position: relative;
  display: flex;
  min-height: 0;
  flex: ${({ $hasConversation }) => ($hasConversation ? '1 1 auto' : '0 0 0')};
  overflow: hidden;
  opacity: ${({ $hasConversation }) => ($hasConversation ? 1 : 0)};
  transition:
    flex ${STAGE_MOVE},
    opacity 200ms var(--ease-out-strong) 120ms;

  @media (prefers-reduced-motion: reduce) {
    transition: opacity 200ms var(--ease-out-strong);
  }
`

export const ComposerStage = styled.div<{ $hasConversation: boolean }>`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  gap: 0.75rem;
  padding-top: ${({ $hasConversation }) =>
    $hasConversation ? '0.25rem' : '1.5rem'};
  transition: padding ${STAGE_MOVE};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const LandingSectionsStage = styled.div<{ $exiting: boolean }>`
  position: relative;
  display: flex;
  flex-basis: 0;
  flex-grow: ${({ $exiting }) => ($exiting ? 0 : 1)};
  flex-shrink: 1;
  min-height: 0;
  opacity: ${({ $exiting }) => ($exiting ? 0 : 1)};
  transform: translateY(${({ $exiting }) => ($exiting ? '0.75rem' : '0')});
  pointer-events: ${({ $exiting }) => ($exiting ? 'none' : 'auto')};
  transition:
    ${LANDING_SECTIONS_COLLAPSE_PROPERTY} ${STAGE_MOVE},
    ${LANDING_SECTIONS_FADE_PROPERTY} ${STAGE_FADE},
    transform ${STAGE_FADE};

  @media (prefers-reduced-motion: reduce) {
    transform: none;
    transition: ${LANDING_SECTIONS_FADE_PROPERTY} ${STAGE_FADE};
  }
`

export const LandingSectionsScroll = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 1.25rem;
  min-height: 0;
  padding-block: 1.5rem 2rem;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
`
